var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./ChooseTrainingDefinition.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-fcfe2ae2!../../node_modules/vue-loader/lib/selector?type=template&index=0!./ChooseTrainingDefinition.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/modals/ChooseTrainingDefinition.vue
// module id = 698
// module chunks = 0